module.exports = __webpack_public_path__ + "static/media/source.92769c8d.svg";